import { render } from "./score.vue?vue&type=template&id=5362b361&scoped=true"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"

import "./score.vue?vue&type=style&index=0&id=5362b361&scoped=true&lang=css"

import exportComponent from "D:\\GitHub\\car\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5362b361"]])

export default __exports__